export interface Driver {
  id?: string
  firstName: string
  lastName: string
  birthDate: string
  gender: string
  citizenship: string
  docIssuedCountry: string
  docType: string
  docNumber: string
  docExpirationDate: string
  scanImage: string
  changed: boolean
  cabinCategory: string
  guestId: number | string
}
export interface CargoUnit {
  country: string
  regNumber: string
  weight: number
  cargoWeight: number
  length: number
  height: number
  width: number
  trailerCountry: string
  trailerRegNumber: string
}
export interface Route {
  portFrom: string
  portTo: string
  pierFrom: string
  pierTo: string
  dateFrom: number
  dateTo: number
  ship: string
}
export interface Note {
  note: string
  recordID: number
  subject: string
  user: string
  createdAt: string
  vouch: { checked: boolean }
}

interface Addons {
  category: string
  code: string
  mandatory: boolean
  quantity: number
  status: string
  type: string
}
export interface Reservation {
  resId: number
  countryFrom: string
  countryTo: string
  content: string
  consigneeName: string
  customerName: string
  drivers: Driver[]
  cargoUnit: CargoUnit
  cargoType: string
  cargoSubType: string
  route: Route
  loaded: boolean
  checkedIn: boolean
  userNote: string
  notes: Note[]
  addons: Addons[]
}

export interface ReservationChange {
  resId: string
  carLicencePlate: string
  trailerRegCountry: string
  trailerLicencePlate: string
  cargoLength: string
  cargoWeight: string
  consignee: string
  countryFrom: string
  countryTo: string
  cargoContent: string
  drivers: Driver[]
  driverIndex: number
  userNote: string
  cargoType: string
}

export const composeReservation = (data: any): Reservation => {
  const cargoUnitData = data.cargoUnit || {}
  const cargoUnit = {
    country: cargoUnitData.country || '',
    regNumber: cargoUnitData.regNumber || '',
    weight: cargoUnitData.weight || 0,
    cargoWeight: cargoUnitData.cargoWeight || 0,
    length: cargoUnitData.length || 0,
    height: cargoUnitData.height || 0,
    width: cargoUnitData.width || 0,
    trailerCountry: cargoUnitData.trailerCountry || '',
    trailerRegNumber: cargoUnitData.trailerRegNumber || '',
  }
  const routeData = data.route || {}
  const route = {
    portFrom: routeData.portFrom || '',
    portTo: routeData.portTo || '',
    pierFrom: routeData.pierFrom || '',
    pierTo: routeData.pierTo || '',
    dateFrom: routeData.dateFrom || 0,
    dateTo: routeData.dateTo || 0,
    ship: routeData.ship || '',
  }
  const drivers = (data.drivers && data.drivers.length > 0 ? data.drivers : [{}]).map((driverData: any = {}) => {
    const driver: Driver = {
      firstName: driverData.firstName || '',
      lastName: driverData.lastName || '',
      birthDate: driverData.birthDate || '',
      gender: driverData.gender || '',
      citizenship: driverData.citizenship || '',
      docIssuedCountry: driverData.docIssuedCountry || '',
      docType: driverData.docType || '',
      docNumber: driverData.docNumber || '',
      docExpirationDate: driverData.docExpirationDate || '',
      scanImage: driverData.scanImage || '',
      changed: !!driverData.changed,
      cabinCategory: driverData.cabinCategory || '',
      guestId: driverData.guestId || '',
    }
    if (driverData.id) {
      driver.id = driverData.id
    }
    return driver
  })
  return {
    resId: data.resId || '',
    countryFrom: data.countryFrom || '',
    countryTo: data.countryTo || '',
    content: data.content || '',
    consigneeName: data.consigneeName || '',
    customerName: data.customerName || '',
    drivers,
    cargoUnit,
    cargoType: data.cargoType || '',
    cargoSubType: data.cargoSubType || '',
    route,
    loaded: !!data.loaded,
    checkedIn: !!data.checkedIn,
    userNote: data.userNote || '',
    notes: data.notes || [],
    addons: data.addons || [],
  }
}
